import StudentAnswer from "models/studentAnswer";
import SelectionQuizA from "models/selectionQuizA/selectionQuizA";
import SelectionQuizAAnswer from "models/selectionQuizA/selectionQuizAAnswer";

export default class SelectionQuizAStudentAnswer
  implements StudentAnswer<SelectionQuizA>
{
  constructor(
    public readonly quiz: SelectionQuizA,
    public readonly answer?: SelectionQuizAAnswer,
    public readonly elapsedTimeMillis?: number
  ) {}

  get isAnswered(): boolean {
    return this.answer !== undefined;
  }

  get isCorrect(): boolean {
    return this.quiz.correctChoiceId === this.answer?.choiceId;
  }

  get answerText(): string | undefined {
    return this.quiz.choices.find(
      (choice) => choice.id === this.quiz.correctChoiceId
    )?.name;
  }
}
